import { Link } from 'react-router-dom';

const footerLinks = {
  影视分类: [
    { name: '电影', path: '/category/movie' },
    { name: '电视剧', path: '/category/tv' },
    { name: '综艺', path: '/category/variety' },
    { name: '动漫', path: '/category/anime' },
  ],
  关于我们: [
    { name: '品牌介绍', path: '/about' },
    { name: '用户口碑', path: '/about#reputation' },
    { name: '联系我们', path: '/about#contact' },
  ],
  帮助中心: [
    { name: '常见问题', path: '/#faq' },
    { name: '使用指南', path: '/#faq' },
    { name: '意见反馈', path: '/about#contact' },
  ],
};

export default function Footer() {
  return (
    <footer className="bg-background-950 text-background-200">
      <div className="w-full px-4 md:px-6 py-14">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
            <div>
              <div className="flex items-center gap-2 mb-4">
                <div className="w-9 h-9 flex items-center justify-center bg-primary-500 rounded-lg">
                  <i className="ri-play-circle-fill text-xl text-white"></i>
                </div>
                <span className="font-heading text-xl font-bold text-white">糖心视频</span>
              </div>
              <p className="text-sm text-background-400 leading-relaxed">
                糖心视频网聚合热门平台资源，最新电影、电视剧、综艺全收录，高清免费在线观看不缓冲。
              </p>
            </div>
            {Object.entries(footerLinks).map(([title, links]) => (
              <div key={title}>
                <h4 className="font-heading text-base font-semibold text-white mb-4">
                  {title}
                </h4>
                <ul className="space-y-2.5">
                  {links.map((link) => (
                    <li key={link.name}>
                      <Link
                        to={link.path}
                        className="text-sm text-background-400 hover:text-white transition-colors cursor-pointer"
                      >
                        {link.name}
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
          <div className="mt-12 pt-8 border-t border-background-800">
            <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
              <p className="text-sm text-background-500">
                &copy; 2024-2026 糖心视频 tangxinsp.com 版权所有
              </p>
              <div className="flex items-center gap-4">
                <a href="#" className="text-sm text-background-500 hover:text-white transition-colors" rel="nofollow">隐私政策</a>
                <a href="#" className="text-sm text-background-500 hover:text-white transition-colors" rel="nofollow">服务条款</a>
                <a href="#" className="text-sm text-background-500 hover:text-white transition-colors" rel="nofollow">免责声明</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}